import { monsterImageMap, playerImageMap, getParticipantImage } from './TournamentAssets';

function getMonsterImage(imageId) {
  const monster = monsterImageMap[imageId] || monsterImageMap[String(imageId || '').replace(/_/g, ' ')];
  return monster?.normal || null;
}

export function getSceneImage(assetId) {
  if (!assetId || typeof assetId !== 'string') return null;
  if (/^(?:https?:)?\/\//i.test(assetId) || assetId.startsWith('/api/')) return assetId;

  if (/^(player\.)?flustered\./.test(assetId)) {
    return getParticipantImage({ imageId: assetId.replace(/^(player\.)?flustered\./, '') }, 'flustered');
  }

  if (assetId.startsWith('player.')) {
    return getParticipantImage({ imageId: assetId });
  }

  if (assetId.startsWith('monster.')) {
    const imageId = assetId.slice('monster.'.length);
    const monsterImage = getMonsterImage(imageId);
    if (!monsterImage && playerImageMap[imageId]) {
      return playerImageMap[imageId];
    }
    return monsterImage;
  }

  if (assetId.startsWith('monsters/')) {
    return getMonsterImage(assetId.slice('monsters/'.length));
  }

  return playerImageMap[assetId] || getMonsterImage(assetId);
}

const SceneAssetRegistry = {
  getSceneImage,
};

export default SceneAssetRegistry;
